import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import MUIDataTable from "mui-datatables";
// import { Button } from "semantic-ui-react";
import { AuthContext } from "../context/auth";

import { FETCH_PROSPECTS_QUERY } from "../util/graphql";
const TableAttributes = require("../variables/TableAttributes.js");

function Table() {
  const { user } = useContext(AuthContext);
  // let newData = [{}];
  const { loading, error, data } = useQuery(FETCH_PROSPECTS_QUERY);

  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;
  if (data) {
    // console.log(data.getProspects);
  }
  // let add_button = (
  //   <Button.Group basic size="small">
  //     <Button icon="download" />
  //   </Button.Group>
  // );
  const editable = data.getProspects.map((o) => ({ ...o }));

  return (
    <div>
      {user && (
        <MUIDataTable
          title={"Prospect Compilation Board"}
          data={editable}
          columns={TableAttributes.p_columns}
          options={TableAttributes.options}
        />
      )}
    </div>
  );
}

export default Table;
